import { Component } from '@angular/core';

@Component({
  selector: 'app-password-reset-successful',
  imports: [],
  templateUrl: './password-reset-successful.component.html',
  styleUrl: './password-reset-successful.component.css'
})
export class PasswordResetSuccessfulComponent {

}
